import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/entrepreneuriat',
    name: 'Entrepreneuriat',
    component: () => import( '../views/Entrepreneuriat.vue')
  },
  {
    path: '/entreprise',
    name: 'Entreprise',
    component: () => import( '../views/Entreprise.vue')
  },
  {
    path: '/a-propos',
    name: 'APropos',
    component: () => import( '../views/APropos.vue')
  },
    {
    path: '/mentions-legales',
    name: 'MentionsLegales',
    component: () => import( '../views/MentionsLegales.vue')
  },
    {
    path: '/politique-confidentialite',
    name: 'PolitiqueConfidentialite',
    component: () => import( '../views/PolitiqueConfidentialite.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
scrollBehavior(to) {
  if (to.hash) {
    return {
      el: to.hash,
      behavior: 'smooth',
    };
  }
  return { top: 0 };
}
});


export default router
